<app-dialog-container
  [title]="'selectTimePeriod'"
  [showCloseButton]="false"
  [showCancelButton]="false"
  [showConfirmButton]="false"
>
  <div class="date-inputs" mat-dialog-content>
    <app-shared-ui-datepicker
      [label]="'fromDate' | translate"
      [control]="fromControl"
      [required]="false"
      [max]="getFromMaxDate()"
    ></app-shared-ui-datepicker>
    <app-shared-ui-datepicker
      [label]="'toDate' | translate"
      [control]="toControl"
      [required]="false"
      [min]="getToMinDate()"
      [max]="data.maxDate"
    ></app-shared-ui-datepicker>
  </div>
  <div class="dialog-actions" mat-dialog-actions>
    <app-ui-button
      buttonType="secondary"
      [text]="'cancel' | translate"
      (click)="cancel()"
    ></app-ui-button>
    <app-ui-button
      color="primary"
      [text]="'apply' | translate"
      [disabled]="!isRangeValid()"
      (click)="apply()"
    ></app-ui-button>
  </div>
</app-dialog-container>
